module.exports = __webpack_public_path__ + "media/images/official/special_workcation_09-c6d492971d600ff02d12ccb931fa7fd6.jpg";